export const NOT_INPUT_ERROR = '入力してください。';
